import { flattenMessages } from './flattenMessages'
import { LOCALE_CATALOG, SUPPORTED_LOCALES } from './types'

/** Locale-agnostic language names shown in every language picker. */
const LANGUAGE_OPTION_MESSAGES = flattenMessages({
  languageSelector: {
    option: Object.fromEntries(SUPPORTED_LOCALES.map((tag) => [tag, LOCALE_CATALOG[tag].endonym])),
  },
})

export function buildLocaleMessages(messages: Record<string, unknown>): Record<string, string> {
  return { ...flattenMessages(messages), ...LANGUAGE_OPTION_MESSAGES }
}
